import { render, staticRenderFns } from "./FormatQuestionnaireSubmissionPseudonymizationPropertyEditor.vue?vue&type=template&id=188ccb9a&scoped=true&"
import script from "./FormatQuestionnaireSubmissionPseudonymizationPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatQuestionnaireSubmissionPseudonymizationPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatQuestionnaireSubmissionPseudonymizationPropertyEditor.vue?vue&type=style&index=0&id=188ccb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ccb9a",
  null
  
)

export default component.exports